import React, { useState, useEffect } from 'react';
import Table from './Table'; // Adjust the path if necessary
import { style } from './styles'; // Adjust the path if necessary

const ServiceReport = () => {
  const [requests, setRequests] = useState([]);
  const [filteredRequests, setFilteredRequests] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [emailSearch, setEmailSearch] = useState('');

  useEffect(() => {
    // Fetch requests data from the backend or a static source
    const fetchRequests = async () => {
      try {
        const response = await fetch('https://backend.pmc-group.uk/api/requests'); // Adjust the URL
        const data = await response.json();
        setRequests(data);
      } catch (error) {
        console.error('Error fetching requests:', error);
      }
    };

    fetchRequests();
  }, []);

  useEffect(() => {
    filterRequests();
  }, [startDate, endDate, emailSearch, requests]);

  const filterRequests = () => {
    let filtered = requests;

    if (startDate) {
      filtered = filtered.filter(request => new Date(request.date) >= new Date(startDate));
    }

    if (endDate) {
      filtered = filtered.filter(request => new Date(request.date) <= new Date(endDate));
    }

    if (emailSearch) {
      filtered = filtered.filter(request => request.email.toLowerCase().includes(emailSearch.toLowerCase()));
    }

    setFilteredRequests(filtered);
  };

  return (
    <div className="p-0 m-0 box-border">
      <div className="w-[98%] mx-auto px-6 py-2 bg-white rounded-xl">
        <div className="flex justify-between p-2">
          <div className="w-120 text-4xl font-semibold text-blue-700" style={style.interText}>
            Service Report
          </div>
        </div>
        <div className="p-4 border-b border-gray-200">
          <div className="flex flex-col gap-4 mb-4">
            <div className="flex flex-col sm:flex-row gap-2 items-end">
              <div className="relative w-full sm:w-auto">
                <label className="block mb-1 text-gray-500">Email</label>
                <input
                  type="text"
                  value={emailSearch}
                  onChange={(e) => setEmailSearch(e.target.value)}
                  className="p-1 border rounded w-full sm:w-80 h-8"
                  placeholder="Search by Email"
                />
              </div>
              <button
                onClick={filterRequests}
                className="p-1 bg-blue-500 text-white rounded hover:bg-blue-700 transition h-8 w-full sm:w-auto"
              >
                Search
              </button>
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
              <div className="relative w-full sm:w-auto">
                <label className="block mb-1 text-gray-500">Start Date</label>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  className="p-1 border rounded w-full sm:w-48 h-8"
                  placeholder="YYYY-MM-DD"
                />
              </div>
              <div className="relative w-full sm:w-auto">
                <label className="block mb-1 text-gray-500">End Date</label>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  className="p-1 border rounded w-full sm:w-48 h-8"
                  placeholder="YYYY-MM-DD"
                />
              </div>
            </div>
          </div>
        </div>
        <Table requests={filteredRequests} />
      </div>
    </div>
  );
};

export default ServiceReport
